// extracted by mini-css-extract-plugin
export var bgImage = "_2g-x";
export var body = "_2g-w";
export var buttonBar = "_2g-6";
export var card = "_2g-0";
export var center = "_2g-11";
export var chevron = "_2g-15";
export var clickable = "_2g-4";
export var closeButton = "_2g-13";
export var collapseHeader = "_2g-7";
export var collapseIcon = "_2g-d";
export var collapseSection = "_2g-b";
export var collapseTitle = "_2g-a";
export var collapseTrigger = "_2g-8";
export var collapsed = "_2g-c";
export var dark = "_2g-1";
export var expandableCard = "_2g-16";
export var expandableCardTitle = "_2g-14";
export var grid = "_2g-5";
export var header = "_2g-f";
export var headerContainer = "_2g-e";
export var headerSubtitle = "_2g-k";
export var headerTitle = "_2g-g";
export var inherit = "_2g-9";
export var large = "_2g-i";
export var left = "_2g-12";
export var linkColor = "_2g-17";
export var medium = "_2g-j";
export var noPadding = "_2g-3";
export var outlined = "_2g-p";
export var scrollable = "_2g-2";
export var section = "_2g-o";
export var sectionHeader = "_2g-s";
export var selected = "_2g-q";
export var separator = "_2g-r";
export var subsection = "_2g-t";
export var subtitle = "_2g-u";
export var subtotalCollapseHeader = "_2g-y";
export var subtotalCollapseHeaderTitle = "_2g-z";
export var subtotalItem = "_2g-10";
export var table = "_2g-l";
export var tableCell = "_2g-n";
export var tableHeader = "_2g-m";
export var title = "_2g-v";
export var titleFullWidth = "_2g-h";